import { Component, Input } from "@angular/core";

@Component({
  selector: "app-purchase-success",
  templateUrl: "./purchase-success.component.html",
  styleUrls: ["./purchase-success.component.scss"],
})
export class PurchaseSuccessComponent {
  @Input() iapProduct: any;

  constructor() {}
}